<template>
  <el-container>
    <el-header style="height: 20px;">
      <span class="company" v-if="currentUser.userType === 1">亲爱的：{{currentUser.person.name}}</span>
      <span class="company" v-if="currentUser.userType === 2">亲爱的：{{currentUser.customer.name}}</span>
      <span class="company" style="margin-left: 10px">当前公司：{{saleOrgName}}</span>
      <el-button class="but3" size="small" @click="changeCompany">点此切换公司</el-button>
      <el-button class="but3" size="small" style="margin-left: -10px" @click="logout">退出登录</el-button>
    </el-header>
    <el-divider class="div_top"></el-divider>
    <el-main class="main">
      <span class="text"><img class="icon_pay" src="@/assets/images/icon_pay.png" alt=""/>直接付款</span>
      <el-steps :active="1" simple style="width:50%;float: right;margin-top: -30px;height: 10px;padding:13px 2%;">
        <el-step title="1 填写付款信息" icon="el-icon-edit-outline"></el-step>
        <el-step title="2 网银操作" icon="el-icon-s-platform"></el-step>
        <el-step title="3 付款成功" icon="el-icon-s-check"></el-step>
        <el-step title="4 公司到账" icon="el-icon-success"></el-step>
      </el-steps>
      <el-button class="but2">
        <img class="icon_input" src="@/assets/images/icon_input.png" alt=""/>
        <span class="sp2">填写付款信息</span>
      </el-button>
      <el-form class="form">
        <el-form-item class="sp3" style="margin-top: 20px" v-if="currentUser.userType === 1">
          <span v-if="selectedCustomer === ''">
            <span style="color: red">*</span>
            <span style="margin-left: 5px">付款公司：</span>
          </span>
          <span v-if="selectedCustomer !== ''">
            <span style="color: red">*</span>
            <span style="margin-left: 5px">付款公司：<span style="font-size: 16px">{{storageOrgInfo[stoDef].orgCompany.name}}</span></span>
          </span>
        </el-form-item>
        <el-form-item class="sp3" style="margin-top: 20px" v-if="currentUser.userType === 2">
          <span style="color: red">*</span>
          <span style="margin-left: 5px">付款公司：<span style="font-size: 16px">{{storageOrgInfo[stoDef].orgCompany.name}}</span></span>
        </el-form-item>
        <!--业务员-->
        <el-form-item class="sp3" v-if="currentUser.userType === 1">
          <span style="color: red">*</span>
          <span style="margin-left: 5px">提货人：
            <el-select v-model="selectedCustomer"
                       placeholder="请选择"
                       filterable
                       :filter-method="dataFilter"
                       ref="select"
                       :clearable="showClose"
                       @blur.native.capture="onblur"
                       @hook:mounted="cancelReadOnly"
                       @visible-change="cancelReadOnly"
                       @change="customerChange();getBalance();queryCenterSettle()">
              <el-option
                v-for="item in customerOption"
                :key="item.id"
                :label="item.name+' & '+item.number"
                :value="item.id">
              </el-option>
            </el-select>
          </span>
        </el-form-item>
        <!--客户-->
        <el-form-item class="sp3" v-if="currentUser.userType === 2">
          <span style="color: red">*</span>
          <span style="margin-left: 10px" v-model="selectedCustomer">提货人：{{currentUser.customer.name}}</span>
        </el-form-item>
        <el-form-item class="sp3">
          <span style="color: red">*</span>
          <span style="margin-left: 5px">付款金额：</span>
          <!--<el-input class="amt" placeholder="请输入付款金额" maxlength="12" v-model="payInfo.payAmount" onkeyup="value=value.match(/\d+\.?\d{0,2}/,'')"></el-input>-->
          <el-popover
            placement="right-end"
            title="网关支付对应手续费信息"
            width="200"
            trigger="manual"
            v-model="visible">
            <p>借记卡：</p>
            <p style="color: red">到账金额：{{this.taxAmount.remainAmount}} <span style="margin-left: 4px"></span> 手续费：{{this.taxAmount.taxAmount}}</p>
            <p>信用卡：</p>
            <p style="color: red">到账金额：{{this.taxAmount.remainVisaAmount}} <span style="margin-left: 4px"></span> 手续费：{{this.taxAmount.taxVisaAmount}}</p>
            <el-input class="amt" slot="reference" placeholder="请输入付款金额" maxlength="12" @blur="getTaxInfo" v-model="payInfo.payAmount" onkeyup="value=value.match(/\d+\.?\d{0,2}/,'')"></el-input>
          </el-popover>
        </el-form-item>
        <el-form-item class="sp3" v-if="currentUser.userType === 1">
          <span style="color: red">*</span>
          <span style="margin-left: 5px">账户余额：</span>
          <span class="balance">{{this.payInfo.customerBalance}}</span>
        </el-form-item>
        <el-form-item class="sp3" v-if="currentUser.userType === 1">
          <span v-if="selectedCustomer === ''">
            <span style="color: red">*</span>
            <span style="margin-left: 5px">选择提货人后展示发货详情</span>
          </span>
          <span v-if="selectedCustomer !== ''">
            <el-radio v-model="stoDef" :key="index" :label="index" v-for="(storage,index) in storageOrgInfo" @change="getBalance" style="min-width: 20vw">
              <span style="color: black">
<!--                <span style="font-weight: bold">发货公司：</span>{{storage.name}}-->
                <span style="font-weight: bold;margin-left: 10px">付款公司：</span>{{ storage.orgCompany.name }}
              </span>
            </el-radio>
          </span>
        </el-form-item>
        <el-form-item class="sp3" v-if="currentUser.userType === 2">
            <el-radio v-model="stoDef" :key="index" :label="index" v-for="(storage,index) in storageOrgInfo" style="min-width: 20vw">
              <span style="color: black">
<!--                <span style="font-weight: bold">发货公司：</span>{{storage.name}}-->
                <span style="font-weight: bold;margin-left: 10px">付款公司：</span>{{ storage.orgCompany.name }}
              </span>
            </el-radio><br>
<!--          <el-radio v-model="stoDef" :label="stoDef">-->
<!--            <span style="color: black">-->
<!--              <span style="font-weight: bold">发货公司：</span>{{storageOrgInfo[stoDef].name}}-->
<!--              <span style="font-weight: bold;margin-left: 10px">付款公司：</span>{{ storageOrgInfo[stoDef].orgCompany.name }}-->
<!--            </span>-->
<!--          </el-radio>-->
        </el-form-item>
      </el-form>
      <!--支付方式-->
      <el-button class="but2" style="margin-top: 20px">
        <img class="icon_input" src="@/assets/images/icon_money.png" alt=""/>
        <span class="sp2">支付方式</span>
      </el-button>
      <el-form class="form">
        <el-form-item class="pay_item" v-if="this.payWayList.indexOf('trustPayShow') !== -1">
          <el-row style="text-align: left">
            <el-col :span="5">
              <el-button style="background: white; border: none"><img src="@/assets/images/yinhang1.gif" @click="abcPay" alt=""/></el-button>
            </el-col>
            <el-col :span="5" style="line-height: 60px">
              <p>农行直联支付</p>
            </el-col>
            <el-col :span="12" style="line-height: 60px">
              <p>支持K码支付和K宝/K令支付，无手续费（二级商户模式）</p>
            </el-col>
            <el-col :span="2" style="line-height: 60px">
              <p>即时到帐</p>
            </el-col>
          </el-row>
        </el-form-item>
<!--        <el-divider class="div_bom"></el-divider>-->
<!--        <el-form-item class="pay_item" v-if="this.payWayList.indexOf('ACPPayShow') !== -1">-->
<!--          <el-row style="text-align: left">-->
<!--            <el-col :span="5">-->
<!--              <el-button style="background: white; border: none"><img src="@/assets/images/yinhang4.png" style="width: 150px" @click="gateWayPay" alt=""/></el-button>-->
<!--            </el-col>-->
<!--            <el-col :span="5" style="line-height: 70px">-->
<!--              <p>所有带银联图标的借记卡及贷记卡</p>-->
<!--            </el-col>-->
<!--            <el-col :span="12" style="line-height: 70px">-->
<!--              <p>需要开通网银</p>-->
<!--            </el-col>-->
<!--            <el-col :span="2" style="line-height: 70px">-->
<!--              <p>即时到帐</p>-->
<!--            </el-col>-->
<!--          </el-row>-->
<!--        </el-form-item>-->
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
import {queryBySale} from "../../../api/system/org-storage";
import {getBalanceAmount, queryCenterSettle, queryCustomerSaleInfoById} from "../../../api/system/customer";
import {abcPCPay, gateWatB2C, getSupportPayWay, getTaxInfo} from "../../../api/system/pay"
import {queryCustomerListById, queryPersonSaleInfoById} from "../../../api/system/person";

export default {
  data() {
    return {
      payInfo: {
        customerBalance:0,
        companyName:'',
        payAmount:'',
      },
      customerOption:[],
      storageOrgInfo:[{
        name:'',
        orgCompany:{
          name:''
        }
      }],
      stoDef:0,
      saleOrgId:'',
      saleOrgName:'',
      currentUser:[],
      selectedCustomer:'',
      showClose:false,
      balance:0,
      customerIndex:-1,
      salePersonId:'',
      html:'',
      payWayList:[],
      visible: false,
      taxAmount: {
        remainAmount: 0,
        taxAmount: 0,
        remainVisaAmount: 0,
        taxVisaAmount: 0
      }
    }
  },
  mounted() {
    //获取当前用户
    this.currentUser = this.$store.getters.currentUser
    //获取当前销售组织ID
    this.saleOrgId = sessionStorage.getItem("saleOrgId")
    //获取当前销售组织名称
    this.saleOrgName = sessionStorage.getItem("saleOrgName")
    this.getUserSaleInfo()
    this.queryOrgBySaleOrg()
    // console.log('付款金额：'+this.$route.query.amount)
    if(this.$route.query.amount !== undefined){
      this.payInfo.payAmount = this.$route.query.amount
      this.selectedCustomer = this.$route.query.selectedCustomer
      // console.log(this.selectedCustomer)
    }

  },
  methods: {
    changeCompany() {
      this.$confirm('确定要切换公司么？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({path: '/system/user/company'})
      }).catch(() => {

      });
    },
    getUserSaleInfo() {
      let param = {}
      param.saleOrgId = this.saleOrgId
      if (this.currentUser.userType === 1) {
        this.personInfo = this.currentUser.person
        this.queryCustomer()
        this.querySaleInfoById()
        this.queryOrgBySaleOrg2()
      } else if (this.currentUser.userType === 2) {
        // this.customerInfo = this.currentUser.customer
        // this.queryPersonListById(this.currentUser.customer.number)
        this.selectedCustomer = this.currentUser.customer.id
        this.querySaleInfoById()
      }
    },
    querySaleInfoById() {
      let param = {}
      param.saleOrgId = this.saleOrgId
      if (this.currentUser.userType === 1) {
        param.personNumber = this.currentUser.username
        queryPersonSaleInfoById(param).then(res => {
          // console.log("querySaleInfoById");
          // console.log(res);
          this.isShowGift = res.data[0].isShowGift
        }).catch({})
      } else if (this.currentUser.userType === 2) {
        param.customerNumber = this.currentUser.username
        queryCustomerSaleInfoById(param).then(res => {
          // console.log("querySaleInfoById");
          // console.log(res);
          this.salePersonId = res.data[0].personId
        }).catch({})
      }
    },
    //获取可用的支付方式
    getSupportPayWay(){
      let param = {}
      param.companyId = this.storageOrgInfo[this.stoDef].id
      getSupportPayWay(param).then(res =>{
        if (res.code === 200) {
          this.payWayList = res.data.payWayList
        }else{
          this.$modal.msgError("没有可用的支付方式")
        }
      }).catch(error=>{
        console.log(error)
      })
    },
    getTaxInfo(){
      if(this.payWayList.indexOf('ACPPayShow') === -1){
        return
      }
      if(this.payInfo.payAmount === ''){
        this.visible = false
        return
      }
      let param = {}
      param.companyId = this.storageOrgInfo[this.stoDef].id
      param.inputAmount = this.payInfo.payAmount
      getTaxInfo(param).then(res =>{
        if (res.code === 200) {
          this.visible = true
          for (let i = 0; i < res.data.data.length; i++) {
            if (res.data.data[i].payWay === "ACPPayShow") {
              this.taxAmount = res.data.data[i]
              break;
            }
          }
        }else{
          this.$modal.msgError("获取网关支付手续费失败，请重试")
        }
      }).catch(error=>{
        console.log(error)
      })
    },
    logout() {
      let that = this;
      that.$modal.confirm('是否确认退出小禾订货平台？').then(function () {
        that.$store.dispatch("LogOut").then(() => {
          that.$store.dispatch("ClearMenu");
          sessionStorage.clear()
          that.$router.push({path: that.redirect || "/login"}).catch(() => {
          });
        }).catch(() => {
        });
      })
    },
    onblur() {
      setTimeout(() => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
          this.$refs.select.blur();
        }
        this.showClose = false
        let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    cancelReadOnly(onOff) {
      if (onOff) { // 打开下拉框 显示可清空按钮
        this.showClose = true
      }
      this.$nextTick(() => {
        if (!onOff) {
          const {select} = this.$refs;
          const input = select.$el.querySelector('.el-input__inner');
          input.removeAttribute('readonly');
          // this.$refs.select.blur();  根据tip自行判断是否添加
        }
      });
    },
    //下拉框开启搜索功能
    dataFilter(val) {
      this.value = val;
      if (val) { //val存在
        this.customerOption = this.customerList.filter((item) => {
          if (!!~item.name.indexOf(val) || !!~item.name.toUpperCase().indexOf(val.toUpperCase()) || !!~item.number.indexOf(val) || !!~item.number.toUpperCase().indexOf(val.toUpperCase())) {
            return true
          }
        })
      } else { //val为空时，还原数组
        this.customerOption = this.customerList;
      }
    },
    queryCenterSettle(){
      if(this.currentUser.userType === 2){
        this.selectedCustomer = this.currentUser.customer.id
      }
      if(this.selectedCustomer === ''){
        return
      }
      let param = {}
      param.saleOrgId = this.saleOrgId
      param.customerId = this.selectedCustomer
      queryCenterSettle(param).then(res => {
        //有客户与发货组织对应关系
        if(res.code === 200 && res.data !== null){
          //判断为业务员登录
          // if(this.currentUser.userType === 1){
          //不存在集中结算
          if(res.data.centreSettle === '0'){
            for(let i = 0; i < this.storageOrgInfo.length; i++){
              //设置为提货的库存组织和财务组织
              if(this.storageOrgInfo[i].id === res.data.storageOrgId && this.storageOrgInfo[i].orgCompany.id === res.data.storageOrgId) {
                this.storageOrgDef = this.storageOrgInfo[i]
                this.stoDef = i
                break;
              }
            }
            //插入一条，设置为默认的财务组织
          }else{
            let currentStorageOrg = this.storageOrgInfoTemp[0];
            currentStorageOrg.id = res.data.storageOrgId
            currentStorageOrg.name = res.data.storageOrgName
            //设置为默认的财务组织
            currentStorageOrg.orgCompany.id = this.storageOrgDefBak.orgCompany.id
            currentStorageOrg.orgCompany.name = this.storageOrgDefBak.orgCompany.name
            for(let i = 0; i < this.storageOrgInfo.length; i++){
              //设置为提货的库存组织和财务组织
              if(this.storageOrgInfo[i].id === res.data.storageOrgId && this.storageOrgInfo[i].orgCompany.id === currentStorageOrg.orgCompany.id) {
                this.storageOrgDef = this.storageOrgInfo[i]
                this.stoDef = i
                break;
              }
            }
            //判断组织列表里是否包含集中结算组织
            if(!this.storageOrgInfo.includes(currentStorageOrg)){
              this.storageOrgInfo.unshift(currentStorageOrg);
            }
          }
        }
      }).catch({

      })
    },
    // queryCenterSettle(){
    //   if(this.selectedCustomer === ''){
    //     return
    //   }
    //   let param = {}
    //   param.saleOrgId = this.saleOrgId
    //   param.customerId = this.selectedCustomer
    //   queryCenterSettle(param).then(res => {
    //
    //     if(res.code === 200 && res.data !== null){
    //       if(this.currentUser.userType === 1){
    //         this.storageOrgDef.id = res.data.storageOrgId
    //         this.storageOrgDef.name = res.data.storageOrgName
    //         for(let i = 0; i < this.storageOrgInfoTemp.length; i++){
    //           if(this.storageOrgInfo.length === this.storageOrgInfoTemp.length) {
    //             this.storageOrgInfo.push(this.storageOrgInfoTemp[i])
    //           }
    //         }
    //       }else if(this.currentUser.userType === 2){
    //         this.storageOrgDef.id = res.data.storageOrgId
    //         this.storageOrgDef.name = res.data.storageOrgName
    //       }
    //     }else{
    //       if(this.currentUser.userType === 1){
    //         this.queryOrgBySaleOrg()
    //       }
    //     }
    //   }).catch({
    //
    //   })
    // },
    queryOrgBySaleOrg2(){
      let param = {}
      param.id = this.saleOrgId
      queryBySale(param).then(res => {
        if (res.code === 200) {
          this.storageOrgInfoTemp = res.data
        }
        if (this.selectedCustomer !== '') {
          this.customerChange()
          this.getBalance()
        }
      });
    },
    queryOrgBySaleOrg() {
      let param = {}
      param.id = this.saleOrgId
      queryBySale(param).then(res => {
        if (res.code === 200) {
          // console.log(res.data)
          this.storageOrgInfo = res.data
          for (let i = 0; i < this.storageOrgInfo.length; i++) {
            if (this.storageOrgInfo[i].isDefault === 1) {
              this.storageOrgDef = this.storageOrgInfo[i]
              this.storageOrgDefBak = this.storageOrgInfo[i]
              this.stoDef = i
              break;
            }
          }

          if(this.currentUser.userType === 2){
            this.queryCenterSettle();
          }
          //获取可用的支付方式
          this.getSupportPayWay()

        } else {
          this.$modal.msgError("获取发货公司失败，请重试")
        }
      });
    },
    queryCustomer() {
      let param = {};
      let saleOrgList = [{id: this.saleOrgId}]
      param.number = this.personInfo.number
      param.orgSaleList = saleOrgList
      // console.log(param)
      queryCustomerListById(param).then(res => {
        if (res.code === 200) {
          this.customerList = res.data
          this.customerOption = res.data
        } else {
          this.$modal.msgError("获取您的客户失败，请联系营业室进行维护")
        }
      });
    },
    getBalance() {
      let param = {};
      if (this.selectedCustomer === '') {
        this.payInfo.customerBalance = 0
        return
      }
      param.companyID = this.storageOrgInfo[this.stoDef].id
      param.customerID = this.selectedCustomer
      // console.log(param)
      getBalanceAmount(param).then(res => {
        if (res.code === 200) {
          // console.log(res)
          this.payInfo.customerBalance = res.data.data.balance
        } else {
          this.$modal.msgError("获取客户余额失败，请重试")
        }
      }).catch(() => {

      });
    },

    //直联付款
    abcPay() {
      let payParam = {};
      if (this.currentUser.userType === 1) {
        if (this.customerIndex === -1) {
          this.$modal.msgWarning("请先选择提货人")
          return
        }
        payParam.customerId = this.customerOption[this.customerIndex].id;
        payParam.customerName = this.customerOption[this.customerIndex].name;
        payParam.customerNumber = this.customerOption[this.customerIndex].number;
        payParam.name = this.currentUser.person.name;
        payParam.salePersonId = this.currentUser.person.id
      } else if (this.currentUser.userType === 2) {
        payParam.customerId = this.currentUser.customer.id
        payParam.customerName = this.currentUser.customer.name;
        payParam.customerNumber = this.currentUser.customer.number;
        payParam.name = this.currentUser.customer.name;
        payParam.salePersonId = this.salePersonId
      }
      let accountMoney = this.payInfo.payAmount.match(/\d+\.?\d{0,2}/, '')
      if (accountMoney == null || accountMoney[0] === '' || accountMoney <= 0) {
        this.$modal.msgWarning("请输入付款金额")
        return
      }
      payParam.accountMoney = accountMoney[0];
      //存储发货公司
      payParam.reposCompanyId = this.storageOrgInfo[this.stoDef].id;
      payParam.reposCompanyName = this.storageOrgInfo[this.stoDef].name;
      //存储付款公司
      payParam.companyId = this.storageOrgInfo[this.stoDef].orgCompany.id;
      payParam.companyName = this.storageOrgInfo[this.stoDef].orgCompany.name;
      //设置支付方式 1：internet网络接入 2：手机网络接入
      payParam.frontPayType = 1;
      //pc端付款
      payParam.payType = 'ABC_PC_PAY'
      payParam.saleCompanyId = this.saleOrgId
      // console.log(this.storageOrgInfo)
      // console.log(payParam)

      abcPCPay(payParam).then(res => {
        if (res.code === 200) {
          let url = res.data.PaymentURL
          this.toPaySuccess()
          window.open(url, '_blank')
        } else {
          // console.log(res);
          this.$modal.msgError("付款失败，请重试");
        }
      }).catch(e => {
        console.log(e);
        this.$modal.msgError("付款失败，请重试");
      })
    },
    gateWayPay() {
      let payParam = {};
      if (this.currentUser.userType === 1) {
        if (this.customerIndex === -1) {
          this.$modal.msgWarning("请先选择提货人")
          return
        }
        payParam.customerId = this.customerOption[this.customerIndex].id;
        payParam.customerName = this.customerOption[this.customerIndex].name;
        payParam.customerNumber = this.customerOption[this.customerIndex].number;
        payParam.name = this.currentUser.person.name;
        payParam.salePersonId = this.currentUser.person.id
      } else if (this.currentUser.userType === 2) {
        payParam.customerId = this.currentUser.customer.id
        payParam.customerName = this.currentUser.customer.name;
        payParam.customerNumber = this.currentUser.customer.number;
        payParam.name = this.currentUser.customer.name;
        payParam.salePersonId = this.salePersonId
      }
      let accountMoney = this.payInfo.payAmount.match(/\d+\.?\d{0,2}/, '')
      if (accountMoney == null || accountMoney[0] === '' || accountMoney <= 0) {
        this.$modal.msgWarning("请输入付款金额")
        return
      }
      if(accountMoney[0] <= 3){
        this.$modal.msgWarning("银联交易必须大于三元，否则会影响结算，造成不便敬请谅解！")
        return
      }

      //银联支付使用的单位默认为分
      payParam.accountMoney = accountMoney[0]
      //存储发货公司
      payParam.reposCompanyId = this.storageOrgInfo[this.stoDef].id;
      payParam.reposCompanyName = this.storageOrgInfo[this.stoDef].name;
      //存储付款公司
      payParam.companyId = this.storageOrgInfo[this.stoDef].orgCompany.id;
      payParam.companyName = this.storageOrgInfo[this.stoDef].orgCompany.name;
      //设置支付方式 07：PC,平板  08：手机
      payParam.frontPayType = '07';
      //银联pc端付款
      payParam.payType = 'GATEWAY_PC_PAY'
      payParam.saleCompanyId = this.saleOrgId
      // console.log(this.storageOrgInfo)
      console.log(payParam)

      gateWatB2C(payParam).then(res => {
        if (res.code === 200) {
          //新窗口打开支付页面
          const myWindow = window.open();
          myWindow.document.write(res.data.html);
          this.toPaySuccess()
        } else {
          this.$modal.msgError("付款失败，请重试");
        }
      }).catch(e => {
        console.log(e);
        this.$modal.msgError("付款失败，请重试");
      })
    },
    customerChange() {
      for (let i = 0; i < this.customerOption.length; i++) {
        if (this.customerOption[i].id === this.selectedCustomer) {
          this.customerIndex = i;
          break;
        }
      }
    },
    toPaySuccess() {
      this.$router.push({path: "/paySuccess"})
    }
  }

}
</script>

<style scoped>
  .main{
    overflow: auto;
    height: 90vh;
  }
  .company{
    font-size: 14px;
    color:rgb(143, 143, 143)
  }
  .but3{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
    font-weight: 600;
  }
  .div_top{
    margin: 12px 0;
  }
  .div_bom{
    margin: 0 0;
  }
  .icon_pay{
    width: 22px;
    height: 22px;
    display: flex;
    margin-top: 3px;
    margin-right: 8px;
  }
  .text{
    display: flex;
    color: rgb(239, 51, 69);
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: left;
    /*margin: 0 8px;*/
  }
  .but2{
    margin-top: 10px;
    position: relative;
    text-align: left;
    width: 100%;
    height: 40px;
    line-height: 17px;
    border:1px solid #EBEEF5;
    border-bottom: none;
    border-radius: 0;
    background-color: #f5f7fa;
  }
  .icon_input{
    position: absolute;
    width: 18px;
    height: 18px;
    margin-top: -1px;
    margin-left: -1px;
  }
  .sp2{
    margin-left: 20px;
    font-size: 16px;
    color: rgb(71, 71, 71);
    font-weight: bold;
  }
  .form{
    border:1px solid #EBEEF5;
  }
  .sp3{
    margin-left: 70px;
  }
  .amt{
    width:215px;
  }
  .pay_item{
    margin-left: 30px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .balance{
    color: rgb(239, 51, 69);
    margin-left: 10px;
  }
  .el-step.is-simple >>> .el-step__title{
    font-size: 14px;
    font-weight: bold;
    max-width: 100%;
  }
</style>
